import { weeklyWorkReportColors } from '../../../utils/dataStatus';

/** @typedef {keyof weeklyWorkReportColors["approver"]} ApprovalStatus */
/** @typedef {keyof weeklyWorkReportColors["imputation"]} ImputationStatus */
/** @typedef {keyof weeklyWorkReportColors["inspector"]} InspectionStatus */

/** @typedef {`approver.${ApprovalStatus}` | `imputation.${ImputationStatus}` | `inspector.${InspectionStatus}`} ActionTypes */
/** @typedef {{type: ActionTypes, payload?: number}} OptimisticUIActions */

/**
 * @typedef OptimisticUIState
 * @property {string} iconColor Color of the imputation type/object icon
 * @property {string} inspectionColor The background color of the lower part of the cell. Inspector's area
 * @property {number} quantity Defined by the approver/inspector in the reject/edit cell actions
 * @property {string} statusColors Tuple of the text color and cell background. e.g "#FFFFFF,#219E66". Approver's area
 */

/** @type {OptimisticUIState} */
export const optimisticInitialState = {
  iconColor: '',
  inspectionColor: '',
  quantity: 0,
  statusColors: ''
};

/**
 * @param {OptimisticUIState} state
 * @param {OptimisticUIActions} action
 */
export const optimisticUIReducer = (state, action) => {
  /** @type {['approver', ApprovalStatus] | ['imputation', ImputationStatus] | ['inspector', InspectionStatus]} */
  const [roleAction, executedAction] = action.type.split('.');

  if (roleAction === 'approver') {
    return {
      ...state,
      quantity: action?.payload ?? state.quantity,
      statusColors: weeklyWorkReportColors[roleAction][executedAction]
    };
  }

  if (roleAction === 'imputation') {
    return {
      ...state,
      iconColor: weeklyWorkReportColors[roleAction][executedAction]
    };
  }

  if (roleAction === 'inspector') {
    return {
      ...state,
      quantity: action?.payload ?? state.quantity,
      inspectionColor: weeklyWorkReportColors[roleAction][executedAction]
    };
  }

  return state;
};
